import React, { ReactElement } from 'react'
import { ProgramGroupDetailsPage } from 'src/ui/page/es/program-group/details/ProgramGroupDetailsPage'

export const ProgramGroupEditPage = (): ReactElement => {
  return <ProgramGroupDetailsPage mode={'edit'} />
}
